import type {
	MaterialSymbolVariant,
} from 'components/material-symbols/symbols';

export enum GameEventType {
	Goal = 'goal',
	Assist = 'assist',
	Substitution = 'substitution',
	PlayerOut = 'playerOut',
	Corners = 'corners',
	Possession = 'possession',
	FreeKicks = 'freeKicks',
	Shots = 'shots',
	Penalties = 'penalties',
	ShotsOnGoal = 'shotsOnGoal',
	Saves = 'saves',
	Passes = 'passes',
	Offsides = 'offsides',
	GoalChance = 'goalChance',
	DuelsWon = 'duelsWon',
	YellowCard = 'yellowCard',
	RedCard = 'redCard',
	PeriodScore = 'periodScore',
}

export interface GameEvent {
	type: GameEventType;
	label: string;
	value?: number | string;
	hidden?: boolean;
	maxEvents?: number;

	events: GameEventItem[];
}

export interface GameEventItem {
	id: number;
	value: number;

	meta: GameEventItemMeta[];

	// Used only to determine whether or not updates take precedence
	willChange?: boolean;
}

interface GameEventItemMetaUser {
	userId: number;
	comment?: string;
}

interface DetailChoice {
	key: string;
	label: string;
}

export interface GameEventItemMeta {
	id?: number;
	gameId?: number;
	gameTeamId?: number;
	type: string;
	period?: number;
	periods?: { label: string; key: number }[];
	periodOffset?: number;
	set?: number;
	sets?: { label: string; key: number }[];
	userId?: number;
	connectedGameEventId?: number;
	comment?: string;
	output?: string;
	addLabel?: string;
	label?: string;
	value?: number;
	icon?: MaterialSymbolVariant;
	detail?: string;
	checkbox?: number;
	choices?: DetailChoice[];
	outputField?: string;
	// Names a sibling user field that must be set before this one applies —
	// the form hides this input until it is
	requiresOutputField?: string;

	user1?: GameEventItemMetaUser;
	user2?: GameEventItemMetaUser;

	willChange?: boolean;
}
